import React from "react";
import styled from "styled-components";
import { Container, FlexContainer, Spacing } from "../Containers";
import { ColorVariables } from "../Colors";
import { RadioCheck } from "../Images/icons";
import { baseLength, getMobileBreakpoint } from "../Styles/globals";
import * as Styled from "./styles";
import Chevron, { ChevronOrientation } from "../Images/icons/Chevron";

const StyledTile = styled(FlexContainer)<{ selected?: boolean }>`
  width: ${baseLength * 150}px;
  min-height: ${baseLength * 16}px;
  background-color: ${ColorVariables.sugar};
  box-shadow: ${(props) => (props.selected ? `0 0 0 3px ${ColorVariables.mint}` : `0 0 0 1px ${ColorVariables.coco3}`)}
      inset,
    0px 4px 4px rgba(208, 204, 193, 0.6);
  padding: ${`${baseLength * 2.5}px ${baseLength * 5}px ${baseLength * 2.5}px ${baseLength * 5}px`};
  border-radius: ${baseLength * 2.5}px;
  cursor: pointer;
  flex-direction: column;
  justify-content: center;
  word-break: break-word;

  transition: width 0.1s ease-in, height 0.1s ease-in, border-color 0.05s ease-in, box-shadow 0.05s ease-in;

  &:hover {
    box-shadow: ${(props) =>
          props.selected ? `0 0 0 3px ${ColorVariables.mint}` : `0 0 0 1px ${ColorVariables.coco3}`}
        inset,
      0px 9px 8px rgba(208, 204, 193, 0.4);
  }

  &:active {
    box-shadow: ${(props) =>
          props.selected ? `0 0 0 3px ${ColorVariables.mint}` : `0 0 0 1px ${ColorVariables.coco3}`}
        inset,
      0px 4px 4px rgba(208, 204, 193, 0.4);
  }

  @media (max-width: ${getMobileBreakpoint}) {
    width: ${baseLength * 82.5}px;
    min-height: ${baseLength * 16}px;
  }
`;

export type RadioTileProps = {
  title?: string;
  subtitle?: string;
  selected?: boolean;
  onClick?: (...args: any) => any;
  className?: string;
  size?: "default" | "large";
  radioButtonDivClass?: string;
  titleClass?: string;
  contentClass?: string;
  isWithArrow?: boolean;
};

const RadioTile = ({
  title = "",
  titleClass = "",
  size = "default",
  subtitle = "",
  selected = false,
  onClick,
  className = "",
  radioButtonDivClass = "",
  contentClass = "",
  isWithArrow = false,
}: RadioTileProps) => {
  const titleClassName = size === "default" ? "small" : "large";
  const bodyClassName = size === "default" ? "small" : "medium";
  const titleSpacing = size === "default" ? 0 : 12;
  const flexAlignItemsForTitle = size === "default" ? "center" : "baseline";
  if (isWithArrow) {
    return (
      <Styled.ArrowButtonTileContainer data-name={title} onClick={onClick} $selected={selected}>
        <Styled.ArrowButtonTileContent>
          <p className="title medium bold">{title}</p>
          {subtitle && <span className="subtitle small">{subtitle}</span>}
        </Styled.ArrowButtonTileContent>
        <Styled.ArrowButtonTileIconCol>
          <Chevron orientation={ChevronOrientation.RIGHT} color={ColorVariables.coco3} />
        </Styled.ArrowButtonTileIconCol>
      </Styled.ArrowButtonTileContainer>
    );
  }
  return (
    <StyledTile data-name={title} className={`tile radio-tile ${className}`} onClick={onClick} selected={selected}>
      <FlexContainer
        className={`radio-tile__content ${contentClass}`}
        width={baseLength * 140}
        $mobileWidth={baseLength * 72.5}
        $alignItems={flexAlignItemsForTitle}
        $justifyContent="space-between"
        transition="width 0.1s ease-in, height 0.1s ease-in"
      >
        <FlexContainer width={baseLength * 126.25} $mobileWidth={baseLength * 65} $flexDirection="column">
          <p
            style={{
              color: ColorVariables.coco,
            }}
            className={`radio-tile__title ${titleClassName} ${titleClass} ${
              subtitle.length > 0 ? "clampText bold" : "clampText-2"
            }`}
          >
            {title}
          </p>
          <Spacing $space={titleSpacing} />
          {subtitle && (
            <p
              style={{
                color: ColorVariables.coco7,
              }}
              className={`${bodyClassName} radio-tile__subtitle`}
            >
              {subtitle}
            </p>
          )}
        </FlexContainer>
        <Container className={radioButtonDivClass}>
          <RadioCheck isChecked={selected} />
        </Container>
      </FlexContainer>
    </StyledTile>
  );
};

export { RadioTile };
